import { StatsData } from './data';
import { StatsStorePropertyFactory } from './store/property.factory';
import { StatsStoreBrokerFactory } from './store/broker.factory';
import { StatsStoreAgentFactory } from './store/agent.factory';
import { StatsStoreUserFactory } from './store/user.factory';

export function StatsDataFactory(): StatsData {
  return new StatsData(
    StatsStorePropertyFactory(),
    StatsStoreAgentFactory(),
    StatsStoreBrokerFactory(),
    StatsStoreUserFactory()
  );
}
